export default {
	type: 'object',
	properties: {
		userId: { type: 'string' },
	},
	required: ['userId'],
	additionalProperties: false,
}
